import React, { Component } from "react";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { loginRequest } from "../../actions/login";
import Nav from "../../components/Nav/Nav";
class Login extends Component {
  state = { email: "", password: "" };

  componentDidUpdate(prevProps) {
    const { error, isLoggedIn } = this.props;
    if (error && error !== prevProps.error) {
      alert("Invalid username and password");
    }

    if (isLoggedIn) {
      browserHistory.replace("/DashBoard");
    }
  }

  handleSubmit = event => {
    event.preventDefault();
    const { email, password } = this.state;
    const { loginRequest } = this.props;
    loginRequest(email, password);
  };

  render() {
    return (
      <div>
        <Nav onlyTitle={true} />
        <div className="col-sm-6 col-sm-offset" style={{ float: "none", margin: "auto" }}>
          <h1> Login </h1>
          <form>
            <div className="form-group">
              <label>Email</label>
              <input className="form-control" value={this.state.email} onChange={event => this.setState({ email: event.target.value })} placeholder="Email" />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                value={this.state.password}
                onChange={event => this.setState({ password: event.target.value })}
              />
            </div>
            <button type="submit" className="btn btn-primary" onClick={event => this.handleSubmit(event)}>
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoggedIn: state.auth.isLoggedIn,
    error: state.auth.error
  };
};

const mapDispatchToPros = dispatch => ({
  loginRequest: (email, password) => dispatch(loginRequest(email, password))
});

export default connect(mapStateToProps, mapDispatchToPros)(Login);



// WEBPACK FOOTER //
// /src/containers/Login/Login.js